import React from 'react';
import { Annotation } from '../components/annotation/annotation';
import { PencilIcon } from '../../../icons/pencil';
import { InitialsIcon } from '../../../icons/initials';
import { CalendarDaysIcon } from '../../../icons/calendar-days';
import { TextCursorIcon } from '../../../icons/text-cursor';
import { LaughIcon } from '../../../icons/laugh';

export function getAnnotationIcon(
	annotationType: Annotation['type'],
	fillColor: string = '#000000',
) {
	switch (annotationType) {
		case 'manuscript':
			return <PencilIcon fillColor={fillColor} />;
		case 'full_name':
			return <LaughIcon fillColor={fillColor} />;
		case 'initials':
			return <InitialsIcon fillColor={fillColor} />;
		case 'date':
			return <CalendarDaysIcon fillColor={fillColor} />;
		case 'text':
			return <TextCursorIcon fillColor={fillColor} />;
	}
}
